var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from "mobx";
import { ConsentFlowDocumentRetrievalLocation } from "healthex-common/screenshot.dtos";
import { NOT_LOADED } from "../Infra/RemoteData";
import { ProxyAccessDto } from "healthex-common/patient.dtos";
import { Exclude, Type } from "class-transformer";
export var PatientConsentSessionState;
(function (PatientConsentSessionState) {
    PatientConsentSessionState["INITIALIZED"] = "INITIALIZED";
    PatientConsentSessionState["RESTORING"] = "RESTORING";
    PatientConsentSessionState["RESTORING_COMPLETED"] = "RESTORING_COMPLETED";
})(PatientConsentSessionState || (PatientConsentSessionState = {}));
export class PatientConsentSession {
    constructor() {
        this.studyId = undefined;
        this._studyVersionId = undefined;
        this.studyPublicInfo = NOT_LOADED;
        this.study = NOT_LOADED;
        this.hasAuthorizedConsentEnrollment = null;
        this.patientInformedConsentEnabled = null;
        this.isInterested = null;
        this.isSubmittingConsent = false;
        this.hasConsentBeenSubmittedThisFlow = false;
        this.consentInfo = null;
        this.existingRetrieval = null;
        this.guidedConsentPatientMRN = null;
        this.guidedConsentLink = null;
        this.guidedConsentPatientSearchResult = NOT_LOADED;
        this.savedConsentedByLink = false;
        this.guidedConsentCloseRoute = null;
        this.patientSignatureHIPAA = null;
        this.patientSigningReasonHIPAA = null;
        this.providerSignature = null;
        this.parentGuardianSignature = null;
        this.parentGuardianSigningReason = null;
        this.additionalParentGuardianSignature = null;
        this.additionalParentGuardianSigningReason = null;
        this.minorParticipantSignature = null;
        this.witnessSignature = null;
        this.additionalParentGuardianExemptSignature = null;
        this.minorParticipantExemptFromAssent = null;
        this.larParticipantExemptSignature = null;
        this.witnessSkipSignature = null;
        this.parentGuardianProxyAccess = null;
        this.additionalParentGuardianProxyAccess = null;
        this.isAdditionalParentGuardianNameUnique = null;
        this.documentRetrievalLocations = [];
        this.retrievalBatchId = null;
        this.contactMethod = null;
        this.contactEmail = null;
        this.contactPhone = null;
        this.currentInteractivePreviewRoute = null;
        this.routeBeforePopup = null;
        this.didEnterConsentFlow = false;
        this.didTryInitialConsentRedirect = false;
        this.enteredViaResume = false;
        this.hasLoggedInDuringConsent = null;
        this.interactivePreviewMetadata = null;
        this._consentFlowPageData = null;
        this.patientConsentSessionState = PatientConsentSessionState.INITIALIZED;
        this.patientCollectedEmail = null;
        this.userChoseToUpdateRecords = null;
        this.locationsNeedingAuthentication = [];
        this.selectedLoginType = null;
    }
}
__decorate([
    observable
], PatientConsentSession.prototype, "studyId", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "_studyVersionId", void 0);
__decorate([
    Exclude(),
    observable
], PatientConsentSession.prototype, "studyPublicInfo", void 0);
__decorate([
    Exclude(),
    observable
], PatientConsentSession.prototype, "study", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "hasAuthorizedConsentEnrollment", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "patientInformedConsentEnabled", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "isInterested", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "isSubmittingConsent", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "hasConsentBeenSubmittedThisFlow", void 0);
__decorate([
    Exclude(),
    observable
], PatientConsentSession.prototype, "consentInfo", void 0);
__decorate([
    Exclude(),
    observable
], PatientConsentSession.prototype, "existingRetrieval", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "guidedConsentPatientMRN", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "guidedConsentLink", void 0);
__decorate([
    Exclude(),
    observable
], PatientConsentSession.prototype, "guidedConsentPatientSearchResult", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "savedConsentedByLink", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "guidedConsentCloseRoute", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "patientSignatureHIPAA", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "patientSigningReasonHIPAA", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "providerSignature", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "parentGuardianSignature", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "parentGuardianSigningReason", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "additionalParentGuardianSignature", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "additionalParentGuardianSigningReason", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "minorParticipantSignature", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "witnessSignature", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "additionalParentGuardianExemptSignature", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "minorParticipantExemptFromAssent", void 0);
__decorate([
    Exclude(),
    observable
], PatientConsentSession.prototype, "larParticipantExemptSignature", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "witnessSkipSignature", void 0);
__decorate([
    Type(() => ProxyAccessDto),
    observable
], PatientConsentSession.prototype, "parentGuardianProxyAccess", void 0);
__decorate([
    Type(() => ProxyAccessDto),
    observable
], PatientConsentSession.prototype, "additionalParentGuardianProxyAccess", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "isAdditionalParentGuardianNameUnique", void 0);
__decorate([
    Type(() => ConsentFlowDocumentRetrievalLocation),
    observable
], PatientConsentSession.prototype, "documentRetrievalLocations", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "retrievalBatchId", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "contactMethod", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "contactEmail", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "contactPhone", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "currentInteractivePreviewRoute", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "routeBeforePopup", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "didEnterConsentFlow", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "didTryInitialConsentRedirect", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "enteredViaResume", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "hasLoggedInDuringConsent", void 0);
__decorate([
    Exclude(),
    observable
], PatientConsentSession.prototype, "interactivePreviewMetadata", void 0);
__decorate([
    Exclude(),
    observable
], PatientConsentSession.prototype, "_consentFlowPageData", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "patientConsentSessionState", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "patientCollectedEmail", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "userChoseToUpdateRecords", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "locationsNeedingAuthentication", void 0);
__decorate([
    observable
], PatientConsentSession.prototype, "selectedLoginType", void 0);
